import { render, staticRenderFns } from "./costExpensesPieChartTwo.vue?vue&type=template&id=2b872046&scoped=true"
import script from "./costExpensesPieChartTwo.vue?vue&type=script&lang=js"
export * from "./costExpensesPieChartTwo.vue?vue&type=script&lang=js"
import style0 from "./costExpensesPieChartTwo.vue?vue&type=style&index=0&id=2b872046&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b872046",
  null
  
)

export default component.exports